// extracted by mini-css-extract-plugin
export default {"ResetPasswordForm":"ResetPasswordFormhdpZa","resetPasswordForm":"ResetPasswordFormhdpZa"};